import React from "react";
import styles from "./data-display.module.scss";

export interface IDataDisplayStatus {
  color: "green" | "orange" | "red" | "Inherit";
  text: "Optimal" | "Degraded" | "Critical" | "N/A";
}

interface IDataDisplayProps {
  icon: JSX.Element;
  title: string;
  value: JSX.Element;
  color?: string;
  highlight?: boolean;
}

function DataDisplay(props: IDataDisplayProps) {
  return (
    <div className={styles.dataDisplay}>
      <div
        className={styles.dataDisplayIcon}
        style={
          props.highlight || props.color
            ? { color: props.color ?? "green" }
            : {}
        }
      >
        {props.icon}
      </div>
      <div className={styles.dataDisplayContent}>
        <div className={styles.dataDisplayTitle}>{props.title}</div>
        <div
          className={styles.dataDisplayValue}
          style={
            props.highlight || props.color
              ? { color: props.color ?? "green" }
              : {}
          }
        >
          {props.value}
        </div>
      </div>
    </div>
  );
}

export default DataDisplay;
